import React from "react";

import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import { Link } from "react-router-dom";

import ApexRadial from "./ApexRadial";

const MonthlyEarning = props => {
  return (
    <React.Fragment>
      {" "}
      <Card>
        <CardBody>
          <CardTitle className="mb-4">Monthly Applications</CardTitle>
          <Row>
            <Col sm="6">
              <p className="text-muted">This month</p>
              <h3>{props.last30DaysTraffic}</h3>
              <p className="text-muted">
                <span className="text-success me-2">
                  {" "}
                  {props.last30DaysTrafficPer}{" "}
                  <i className="mdi mdi-arrow-up"></i>{" "}
                </span>{" "}
                From last month
              </p>
            </Col>
            <Col sm="6">
              <div className="mt-4 mt-sm-0">
                <ApexRadial successRate={props.reqCount30Days}/>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default MonthlyEarning;
